import { ActionType } from '../../core/redux/actionType';
import { makeApiAction, makeRsaaTypes, ApiReducer, makeApiReducer } from '../../core/api/rsaa';
import { Endpoints } from '../../core/api/endpoints';
import { getLoading, addLoading, addError, noLoadingNoError } from '../../core/api/module';
import { SendTo } from '../survey/raters/models';


const KEY_ACTION = ActionType.SendGoalsRequest;
const ACTIONS    = [
  ActionType.SendGoalsRequest,
  ActionType.SendGoalsResponse,
  ActionType.SendGoalsError,
];


type Payload = string;


type Meta = {
  projectId: number;
};


/**
 * Dispatch this action to send goals email to selected email address
 * and participant
 *
 * @param projectId - the project to which we wish to invite raters
 * @param participantId - the specific project participant for whom we wish to invite raters
 * @param comment - a custom comment included in the email sent out to invited raters
 * @param to - the list of email addresses to invite (along with the language that should be used for each message)
 */
export const sendGoalsAction = (
  projectId: number,
  participantId: number,
  comment: string,
  to: SendTo[],
) => makeApiAction<Payload, Meta>(
  {
    method:   'POST',
    endpoint: Endpoints.SendGoals,
    headers:  { 'content-type': 'application/json', 'accept': 'application/json' },
    body:     JSON.stringify({ projectId: projectId, participantId: participantId, comment: comment, to: to }),
    types:    makeRsaaTypes<Payload, Meta>(ACTIONS, { projectId: projectId }),
    bailout:  state => !!getLoading(state, KEY_ACTION, `${projectId}`),
  },
);

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  const metaTag = `${action.meta.projectId}`;

  if (isLoading) {
    return addLoading(state, KEY_ACTION, metaTag);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg, metaTag);
  }

  // The send goal endpoint could return 200 on failure, but with an informative error message
  if (payload !== 'Success') {
    return addError(state, KEY_ACTION, payload || '');
  }
  
  return noLoadingNoError(state, KEY_ACTION, metaTag);
};

export const sendGoalsReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);
